import styled, { css } from "styled-components/native";
import { Props } from "./model";
import { royal_blue_hex } from "../../StyleHelpers";

export const StyledContainer = styled.View`
	display: flex;
	height: 160px;
	padding: 0px 67px;
	justify-content: center;
	align-items: center;
	border-radius: 16px;
	background: ${royal_blue_hex};
`;

export const StyledText = styled.Text<Props>`
	color: #fff;
	${(props) =>
		props.disabled &&
		css`
			opacity: 0.5;
		`}

	font-size: 32px;
	font-style: normal;
	line-height: 28px;
`;

export const StyledCodeWrapper = styled.View<Props>`
	display: flex;
	width: 344px;
	padding: 66px 22px 16px 22px;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	gap: 34px;
	flex-shrink: 0;
	border-radius: 16px;
	background: rgba(255, 255, 255, 0.2);
	${(props) =>
		props.isMobile &&
		css`
			background: transparent;
			align-items: "";
			padding: 66px 22px 16px 0px;
		`}
`;

export const StyledCodeText = styled.Text`
	color: #fff;
	font-size: 50px;
	font-style: normal;
	font-weight: 500;
	line-height: 28px; /* 56% */
	letter-spacing: 2px;
`;

export const StyledSpinnerWrapper = styled.View`
	margin-top: -20px;
`;
